import { render } from "./access-dialog-approve.vue?vue&type=template&id=51cf4087"
import script from "./access-dialog-approve.vue?vue&type=script&lang=js"
export * from "./access-dialog-approve.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__